<template>
  <div class="sub-page">
    <div class="sub-header" style="background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));">
      <van-nav-bar :title="$t('setting.base_setting') || '基本資訊'" class="sub-nav">
        <template #left>
          <van-icon name="arrow-left" color="#fff" @click="back()"/>
        </template>
      </van-nav-bar>
    </div>

    <div class="sub-body">
      <div class="card form-card">
        <div class="item van-hairline--bottom" @click="openHerderImg()">
          <div class="left">{{$t("setting.avatar")}}</div>
          <div class="right">
            <img src="/img/mine/avatar.png" style="width: 47px;height: 47px;border-radius: 50%;">
          </div>
        </div>

        <div class="item van-hairline--bottom">
          <div class="left">{{$t('foorter.top25') || '帳號'}}</div>
          <div class="right">
            <span class="desc">{{userInfo.username ? userInfo.username : $t("setting.no_setting")}}</span>
            <van-icon name="arrow" />
          </div>
        </div>

        <div class="item van-hairline--bottom" @click="toSetName()">
          <div class="left">{{$t("setting.real_name")}}</div>
          <div class="right">
            <span class="desc">{{userInfo.name ? userInfo.name : $t("setting.no_setting")}}</span>
            <van-icon name="arrow" />
          </div>
        </div>

        <div class="item van-hairline--bottom" @click="toSetSex()">
          <div class="left">{{$t("setting.sex")}}</div>
          <div class="right">
            <span class="desc">{{userInfo.sex !== "0" ? (userInfo.sex === "1" ? $t("setting.man") : $t("setting.female")) : $t("setting.unkown")}}</span>
            <van-icon name="arrow" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActive: false,
      show: false,
      isBank: false,
      userInfo: {}
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    toSetName() {
      this.$router.push({ path: '/Setname' });
    },
    toSetBank() {
      this.$router.push({ path: '/Setbank' });
    },
    toSetSex() {
      this.$router.push({ path: '/Setsex' });
    },
    openHerderImg() {
      this.show = true;
    },
    getUserInfo() {
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res => {
        if (res && res.code === 200) {
          this.userInfo = res.data;
        }
      });
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    } else {
      this.getUserInfo();
    }
  }
};
</script>

<style scoped>
.sub-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f3f3f5;
  padding-bottom: 60px;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Helvetica Neue", STHeiti, "Microsoft Yahei", Tahoma, Simsun, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.sub-header {
  position: relative;
  width: 100%;
  height: 220px;
  background-image: url('/img/mine/login-bg.png'), linear-gradient(90deg, rgb(79, 43, 138), rgb(245, 96, 205));
  background-size: 100% auto;
  background-position: center bottom;
  background-repeat: no-repeat;
  box-sizing: border-box;
}

.sub-nav {
  background: transparent !important;
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__content {
  height: 100px;
}

::v-deep .sub-nav .van-nav-bar__title {
  color: #ffffff !important;
  font-size: 34px !important;
  font-weight: 600 !important;
  line-height: 100px;
}

::v-deep .sub-nav .van-icon {
  color: #ffffff !important;
  font-size: 44px !important;
}

.sub-body {
  padding: 0 30px;
  margin-top: -60px;
  position: relative;
  z-index: 10;
}

.form-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 20px 30px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.05);
}

.item {
  padding: 30px 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 28px;
  color: #333333;
}

.item .right {
  display: flex;
  align-items: center;
}

.item .right .desc {
  font-size: 28px;
  color: #999999;
  margin-right: 10px;
}
</style>
